import { lazy } from 'react';

export const ExamList = lazy(() => import('./ExamList'));
export const AddExam = lazy(() => import('./AddExam'));
export const UpdateExam = lazy(() => import('./UpdateExam'));
export const ExamDetails = lazy(() => import('./ExamDetails'));
